"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { PRODUCTS_BINDING, PRODUCTS_BINDING_INPUT } from "@/libs/builder/consts";

export const InnerContainerComponent: RegisteredComponent = {
  name: "InnerContainer",
  component: dynamic(async () => (await import("./InnerContainer")).InnerContainer),
  inputs: [PRODUCTS_BINDING_INPUT],
  canHaveChildren: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
  childRequirements: {
    message: "Only InnerContainer related components are allowed",
    query: {
      "component.name": {
        $in: ["Columns", "List", "ShopTeaser", "SimpleProductTeaser", "ImageNavLinksList"],
      },
    },
  },
  defaults: {
    bindings: PRODUCTS_BINDING,
  },
};
